import React from 'react';
interface Props {
  children?: any;
  title: string;
  description?: string;
  noindex?: boolean;
}
const SEO = ({ title, description, noindex, children }: Props) => {
  return (
    <>
      <title>{title}</title>
      {description && (
        <meta
          name="description"
          content={description}
        />
      )}
      {noindex && (
        <meta
          name="robots"
          content="noindex"></meta>
      )}
      {children}
    </>
  );
};

export default SEO;
